import Vue from 'vue';
import * as Sentry from '@sentry/browser';
import * as Integrations from '@sentry/integrations';
import VeeValidate from 'vee-validate';
import { lsErrorService, lsI18nService, lsValidationService } from 'ls-vue-common';

// need to add some type of new library or initialization logic? well hold your 🐎🐎 just a minute.
// we want to go ahead and do that in the /init.js file imported below, so we don't have to duplicate.
import './init';

import App from './App.vue';
import router from './router';
import store from './store';
import { internationalizationMixin, lsScreenSizeMixin } from '@/mixins';
import { createProvider } from './vue-apollo';
import { lsInternationalizationHelpers } from '@/helpers';

Sentry.init({
  dsn: 'https://7a64fe4d24c140af9099be12c5818127@sentry.io/1367049',
  integrations: [new Integrations.Vue({ Vue, attachProps: true })],
  environment: process.env.VUE_APP_ENVIRONMENT,
  release: process.env.VUE_APP_VERSION,
  ignoreErrors: [
    'Invalid or Missing X-Auth-Token',
    'Network error',
    'Password reset required',
    'The email and password did not match',
    'There was a network error',
    'This password recovery has already been used or has expired',
    'Unauthorized',
    'You are not authorized to perform this action',
    'unexpected error',
  ],
});

lsInternationalizationHelpers.initI18n();

// add brand tag
Sentry.setTag('brand', process.env.VUE_APP_BRAND_DOMAIN);

//https://github.com/vuejs/vue/issues/8433
// Vue internally will not call logError due to a current know limitation
// We need to manually send errors to Sentry, so we can also still show them in the console
Vue.config.errorHandler = function(error) {
  if (error) {
    lsErrorService.log({ error });
  }
};

Vue.config.productionTip = false;
Vue.use(VeeValidate, { inject: false });

lsValidationService.extendVeeValidate();

new Vue({
  router,
  store,
  lsI18nService,
  mixins: [lsScreenSizeMixin, internationalizationMixin],
  apolloProvider: createProvider(),
  render: (h) => h(App),
}).$mount('#app');
